import {ReactNode} from 'react';
import cn from 'clsx';
import {Trans, useTranslation} from 'react-i18next';
import {useReservation} from 'context/reservation';
import {useFetchPrivacyPolicySettings} from 'hooks/useFetchPrivacyPolicySettings';

const linkClasses = 'underline text-[var(--primary)] font-medium';

export function AirbnbSubmitDisclosure({className}: {className?: string}) {
  const {t} = useTranslation();
  const {housingId} = useReservation();
  const {hasCustomPrivacyPolicy, documentDownload, isLoading} =
    useFetchPrivacyPolicySettings({housingId});

  const chekinPolicyLink: ReactNode = hasCustomPrivacyPolicy ? (
    <a
      href={documentDownload || undefined}
      download
      aria-disabled={isLoading || !documentDownload}
      className={linkClasses}
    />
  ) : (
    <a
      href={t('guest_privacy_policy_link')}
      target="_blank"
      rel="noreferrer"
      className={linkClasses}
    />
  );

  return (
    <p
      className={cn(
        'text-left m-0 text-[12px] md:text-[14px] font-normal leading-[18px] text-[#222222]',
        className,
      )}
    >
      <Trans
        i18nKey="airbnb_submit_disclosure"
        components={{
          strong: <strong />,
          chekinLink: (
            <a
              href="https://chekin.com/"
              target="_blank"
              rel="noreferrer"
              className={linkClasses}
            />
          ),
          chekinPolicy: chekinPolicyLink,
        }}
      />
    </p>
  );
}
